import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { queryClient } from '@/api/query-client';
import { useTheme } from '@/lib/theme';
import { router } from '@/router';

export function App() {
  const { pref } = useTheme();
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" theme={pref} closeButton richColors toastOptions={{ duration: 4000 }} />
    </QueryClientProvider>
  );
}
